<template>
  <ClientOnly>
    <Teleport to="#modal">
      <div class="modal">
        <div
          class="modal__overlay"
          @click.self="$emit('close')"
        >
          <div class="modal__wrapper">
            <div class="modal__content">
              <div :class="['modal__header', { 'modal__header--sticky': isStickyHeader }]">
                <div
                  class="modal__close"
                  @click="$emit('close')"
                >
                  <div class="content__close-icon" />
                </div>
                <slot name="header" />
              </div>
              <slot />
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
const BLOCKED_CLASS = 'no-scroll';

defineEmits(['close']);
defineProps({
  isStickyHeader: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});

let wasBlocked = false;

onMounted(() => {
  wasBlocked = document.documentElement.classList.contains(BLOCKED_CLASS);

  if (!wasBlocked) {
    document.documentElement.classList.add(BLOCKED_CLASS);
  }
});
onUnmounted(() => !wasBlocked && document.documentElement.classList.remove(BLOCKED_CLASS));
</script>

<style lang="scss" scoped>
.modal {
  z-index: 999;
  position: relative;

  &__overlay,
  &__wrapper {
    width: 100dvw;
    display: flex;
    justify-content: center;
  }

  &__overlay {
    align-items: center;
    height: 100dvh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }

  &__wrapper {
    overflow-y: auto;
    z-index: 20;
    max-height: 100%;
  }

  &__content {
    background-color: #fff;
    position: relative;
    height: max-content;
  }

  .content {
    &__close-icon {
      background-image: url('@kino/assets/close.svg');
      height: 18px;
      width: 18px;
    }
  }

  &__header {
    &--sticky {
      position: sticky;
      left: 0;
      top: 0;
    }
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    width: 41px;
    height: 41px;
    background-color: #90979d;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;

    &:hover {
      background-color: #7d8489;
    }
  }
}
</style>
